import {
    RETRY_COUNT,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";
import { useQuery } from "@tanstack/react-query";

import { UserOverview } from "api/generated/model";
import { getUsersUserId } from "api/generated/users/users";

export const SEARCH_USER_QUERY_KEY = "user:get";

export const useUserOverviewQuery = (
    id: number | undefined | null,
    initialData?: UserOverview
) =>
    useQuery({
        queryKey: [SEARCH_USER_QUERY_KEY, id],
        enabled: id !== undefined && id !== null,
        queryFn: () => {
            if (id === undefined || id === null) {
                throw new Error("Expected a user ID");
            }
            return getUsersUserId(id).then((response) =>
                toUserOverview(response.data.content.resource)
            );
        },
        staleTime: STALE_TIME_RESOURCES,
        retry: RETRY_COUNT,
        initialData,
    });

function toUserOverview(user: UserOverview): UserOverview {
    return {
        id: user.id,
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
    };
}
